import type { TFunction } from 'i18next'

import { ProductUnitCategory } from '../enums/productUnitCategory'
import type { ProductUnit } from '../types/productUnit'
import { getProductUnitCategory } from './getProductUnitCategory'

// Custom units are shown exactly as the user typed them; only standard units carry a label to translate
export const getProductUnitName = (unit: ProductUnit, t: TFunction, lng?: string): string => {
  if (!unit.label || getProductUnitCategory(unit) === ProductUnitCategory.Custom) {
    return unit.name ?? ''
  }

  return lng ? t(unit.label, { lng }) : t(unit.label)
}
